import React from 'react';
import PropTypes from 'prop-types';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { Collapse } from '@mui/material';

import { useTheme } from 'contexts/ThemeContext';

import { Text } from 'components/DataDisplay';
import { Container, Item } from 'components/Layout';

// Section repliable : carte bordée, titre en capitales, chevron.
export const AccordionSection = ({
  title,
  tooltip,
  isExpanded,
  onToggle,
  children
}) => {
  const { themeColors } = useTheme();
  const { designSystem } = themeColors;

  return (
    <Container
      flex
      style={{
        width: '100%',
        flexDirection: 'column',
        alignItems: 'stretch',
        border: `1px solid ${designSystem.line}`,
        borderRadius: '10px',
        overflow: 'hidden',
        marginBottom: '10px'
      }}
    >
      <Item
        flex
        onClick={onToggle}
        style={{
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '10px',
          padding: '11px 12px',
          cursor: 'pointer'
        }}
      >
        <Item
          flex
          style={{
            alignItems: 'center',
            gap: '7px',
            justifyContent: 'flex-start'
          }}
        >
          <Text
            component="span"
            uppercase
            fontSize="12px"
            fontWeight={700}
            style={{ letterSpacing: '0.4px', color: designSystem.inkSoft }}
          >
            {title}
          </Text>
          {tooltip}
        </Item>
        {isExpanded ? (
          <KeyboardArrowDownIcon style={{ fill: designSystem.faint }} />
        ) : (
          <KeyboardArrowRight style={{ fill: designSystem.faint }} />
        )}
      </Item>
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <Item
          flex
          style={{
            flexDirection: 'column',
            alignItems: 'stretch',
            padding: '4px 12px 12px',
            borderTop: `1px solid ${designSystem.lineSoft}`
          }}
        >
          {children}
        </Item>
      </Collapse>
    </Container>
  );
};

AccordionSection.defaultProps = {
  tooltip: null
};

AccordionSection.propTypes = {
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.node,
  isExpanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

export default AccordionSection;
